import $ from 'jquery';
import Swal from 'sweetalert2';
import { generateGrid } from './generateGrid';
import customLayouts from './customLayouts';
import { TAGLIERINA_MEMENTO_SANTINI_FORMAT_ID } from './provinoFormats';
import { canUseTaglierinaMementoSantini } from './taglierinaMementoSantiniAccess';
import { saveExportSettings } from './exportSettingsStorage';
import { handlePageImageError } from '~core/handlePageImageError';

export const downloadGridPdf = async () => {
  Swal.fire({
    text: "Sto generando l'immagine...",
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    confirmButtonColor: '#278e8e',
    didOpen: () => {
      Swal.showLoading();
    },
  });

  const pdfParameters = $('#navbar-submenu-export-provino-output').select2(
    'data'
  );

  const grigliaProvinoFormatId = pdfParameters[0].id;
  // Il formato con la configurazione Memento di Santini e' riservato alle
  // organizzazioni autorizzate: per tutte le altre si genera la griglia di
  // default.
  const isFormatForbidden =
    grigliaProvinoFormatId === TAGLIERINA_MEMENTO_SANTINI_FORMAT_ID &&
    !canUseTaglierinaMementoSantini();
  const gridGenerator = isFormatForbidden
    ? generateGrid
    : customLayouts[grigliaProvinoFormatId]?.default || generateGrid;

  let pdf;
  try {
    pdf = await gridGenerator();
  } catch (error) {
    await handlePageImageError(error);
    return;
  }
  pdf.pdfGrid.save(pdf.fileName);

  saveExportSettings({
    formatId: grigliaProvinoFormatId,
    outerPadding:
      document.getElementById('outer-provino-grid-padding')?.checked ?? true,
    innerPadding:
      document.getElementById('inner-provino-grid-padding')?.checked ?? true,
  });

  Swal.fire({
    title: 'Fatto!',
    html: "L'immagine &egrave; stata scaricata.",
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
  setTimeout(() => {
    Swal.hideLoading();
  }, 50);
};

export default downloadGridPdf;
